export enum StickyBuyRowPosition {
  BOTTOM = 'bottom',
  TOP = 'top'
}
